import gql from "graphql-tag"

const ENABLE_USER = gql`
    mutation enableUser(
        $username: ID!
    ) {
        enableUser(
            username: $username
        ) {
          status
        }
    }
`

export default ENABLE_USER
